// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-fRW4","colMin":"styles_colMin__1bu_U"};